var REGEXP_SORTCODE = new RegExp('[0-9]{2}', 'g');
export function getLabelledAccountItems(accountId) {
  if (accountId.has('bic') && accountId.has('iban')) return [{
    label: 'bic',
    value: accountId.get('bic')
  }, {
    label: 'iban',
    value: accountId.get('iban')
  }];
  if (accountId.has('bic') && accountId.has('other')) return [{
    label: 'bic',
    value: accountId.get('bic')
  }, {
    label: 'other',
    value: accountId.get('other')
  }];
  if (accountId.has('iban')) return [{
    label: 'iban',
    value: accountId.get('iban')
  }];
  if (accountId.hasIn(['bban', 'sortCode'])) return [{
    label: 'sort-code',
    value: accountId.getIn(['bban', 'sortCode'])
  }, {
    label: 'account-number',
    value: accountId.getIn(['bban', 'accountNumber'])
  }];
  if (accountId.hasIn(['pan', 'maskedPAN'])) return [{
    label: 'pan',
    value: "".concat(accountId.getIn(['pan', 'maskedPAN']))
  }];
  if (accountId.has('ncc')) return [{
    label: 'account-number',
    value: accountId.get('other')
  }, {
    label: 'ncc',
    value: accountId.get('ncc')
  }];
  return [];
}
export function getAccountItems(accountId) {
  return getLabelledAccountItems(accountId).map(function (_ref) {
    var value = _ref.value;
    return value;
  });
}
export function getAccountDetails(accountId) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return getAccountItems(accountId).join(separator);
}
export function getAccountBalance(account, isNonPersonal) {
  return isNonPersonal ? account.get('availableBalance') : account.get('currentBalance');
}
export var formatSortCode = function formatSortCode(sortcode) {
  var match = String(sortcode).match(REGEXP_SORTCODE);
  if (match) return match.join('-');else return sortcode || '';
};
export var updateSortCode = function updateSortCode(path) {
  return function (obj) {
    return obj.updateIn(path, function (sortCode) {
      return sortCode && formatSortCode(sortCode);
    });
  };
};
export var updateBalanceAndCurrency = function updateBalanceAndCurrency(account) {
  if (account.has('balances')) {
    return account.merge({
      availableBalance: account.getIn(['balances', 0, 'availableBalance']),
      currentBalance: account.getIn(['balances', 0, 'currentBalance']),
      currency: account.getIn(['balances', 0, 'currency']),
      expectedBalance: account.getIn(['balances', 0, 'expectedBalance']),
      overdraftLimit: account.getIn(['balances', 0, 'overdraftLimit']),
      overdraftRemaining: account.getIn(['balances', 0, 'overdraftRemaining']),
      pendingTransactions: account.getIn(['balances', 0, 'pendingTransactions'])
    });
  }
  return account;
};
export var getLastBalanceUpdatedDate = function getLastBalanceUpdatedDate(accounts) {
  if (!accounts || accounts.size === 0) {
    return;
  }
  var balanceDate = '';
  accounts.map(function (account) {
    var balanceAt = account.get('balanceAt');
    if (!balanceDate) {
      balanceDate = balanceAt || '';
    } else {
      balanceDate = balanceAt && balanceAt < balanceDate ? balanceAt : balanceDate;
    }
  });
  return balanceDate;
};
export function getAccountDisplayName() {
  var accountName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var accountType = arguments.length > 1 ? arguments[1] : undefined;
  if (accountType !== 'IBBA' || !accountName.includes('&')) {
    return {
      accountDisplayName: accountName,
      isLongName: false
    };
  }
  var accountNameParts = accountName.split('&');
  var isLongName = accountNameParts.filter(function (namepart) {
    return namepart.length > 46;
  }).length > 0;
  var accountDisplayName = accountNameParts.map(function (name, index) {
    return name.length > 46 ? "".concat(name.slice(0, 44), "...") : "".concat(name).concat(index === accountNameParts.length - 1 ? '' : '&');
  });
  return {
    accountDisplayName: accountDisplayName.join(''),
    isLongName: isLongName
  };
}